import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { percentageFormatter } from '../../../common/utils/helpers';
import { selectToken } from '../../../features/auth/ducks';
import { connect } from 'react-redux';
import { OpenFileLink } from '../../../common/components/data-display';

import Table from 'antd/lib/table';
import { ResponsiveTable } from '../../../common/components/data-display';

const Column = Table.Column;
const mapStateToProps = state => ({
    token: selectToken(state)
});


@translate()
@connect(mapStateToProps)
export default class EmailsDashboard extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        data: PropTypes.object
    };

    render() {
        const {
            data,
            t,
            token
        } = this.props;

        const emailLogs = Object.entries(data.emailLogs).map(emailSubject => {
            return {
                subject: emailSubject[0],
                today: emailSubject[1].today,
                yesterday: emailSubject[1].yesterday,
                thisMonth: emailSubject[1].thisMonth,
                lastMonth: emailSubject[1].lastMonth,
            }
        }).sort((a, b) => (a.thisMonth.count < b.thisMonth.count) ? 1 : ((b.thisMonth.count < a.thisMonth.count) ? -1 : 0))


        return (

            <div>
                <table style={{ width: "100%" }}>
                    <tbody>
                        <tr>
                            <td style={{ width: "40%" }} ></td>
                            <td style={{ textAlign: "center" }} >{t("Zaslané (Otvorené %)")}</td>
                        </tr>
                    </tbody>
                </table >
                <ResponsiveTable
                    dataSource={emailLogs}
                    pagination={false}
                    rowClassName={(record) => record.style ? `section-row-${record.style}` : ``}>
                    <Column
                        title={t('Predmet e-mailu')}
                        // className='dashboard-col-5'
                        dataIndex="subject"
                        key="subject"
                        render={value => t(value)}
                    />
                    <Column
                        title={t('Dnes')}
                        // className='dashboard-col-5'
                        dataIndex="today"
                        key="today"
                        render={value => `${value.count} (${percentageFormatter(value.count > 0 ? value.amount / value.count : 0, 2)})`}
                    />
                    <Column
                        title={t('Včera')}
                        // className='dashboard-col-5'
                        dataIndex="yesterday"
                        key="yesterday"
                        render={value => `${value.count} (${percentageFormatter(value.count > 0 ? value.amount / value.count : 0, 2)})`}

                    />
                    <Column
                        title={t('Tento mesiac')}
                        // className='dashboard-col-5'
                        dataIndex="thisMonth"
                        key="thisMonth"
                        render={value => `${value.count} (${percentageFormatter(value.count > 0 ? value.amount / value.count : 0, 2)})`}

                    />
                    <Column
                        title={t('Minulý mesiac')}
                        // className='dashboard-col-5'
                        dataIndex="lastMonth"
                        key="lastMonth"
                        render={value => `${value.count} (${percentageFormatter(value.count > 0 ? value.amount / value.count : 0, 2)})`}

                    />
                </ResponsiveTable>
                {
                    token && <table>

                        <tbody>
                            <tr>
                                <td>Export prehľadu zaslaných e-mailov za posledných 30 dní:   </td>
                                <td></td>
                                <td>
                                    <OpenFileLink
                                        isButton
                                        href={`${process.env.REACT_APP_API_URL}/messaging/report/emails?token=${token}`}
                                    >
                                        {t('Export')}
                                    </OpenFileLink>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                }
            </div >

        );
    }
}



// WEBPACK FOOTER //
// ./src/features/messaging-dashboard/components/EmailsDashboard.js